import * as og from "./widget/og.ts";
import {mustache} from "./handlebars_family.ts";
import TPL from "./widget/og.mustache";
import Icons from "./svg/Icons.ts";

var
  // Declare aliases
  linkMatcher = /https?:\/\/[\w-]+\.[^\s()‘’“”«»]*/g;
  
  /**
   * mode undefined : og are inlined in the result
   * mode false : no og in the result but keep links
   * mode true : just og in the result
   * 
   */
export function render(text :string,mode :boolean|undefined){
  var result = ''  
  
  if(mode===true){
    text.replace(linkMatcher,function(url){
      if(TPL && og.cache[url]){
        result += mustache(TPL,og.cache[url]);
      }else{
        result += "<a href='"+url+"' data-widget='widget/og' target='_new'></a>";
      }
      return ''
    });
    return result;
  }else if(mode===false){
    result = text.replace(linkMatcher,function(url){
      if(url===text){
        return "";
      }else{
        return "<a href='"+url+"' target='_new'>"+url+"</a>";
      }
    });
  }else{
    result = text.replace(linkMatcher,function(url){
      if(TPL && og.cache[url]){
        return mustache(TPL,og.cache[url]);
      }else{
        return "<a href='"+url+"' data-widget='widget/og' target='_new'>"+url+"</a>";
      }
    });
  }
  return result.replace('❤','<icon style="color:#FF6C87">'+Icons.ic_added_to_favorites+'</icon>')
}